import type { AdvisorOption } from '@performance-crm/shared';

/** Fila del diálogo de la regla: un asesor de la empresa o un id guardado en la regla que ya no está. */
export interface RuleAdvisorRow {
  id: string;
  fullName: string;
  role: string;
  isTestAccount: boolean;
  /** Si hoy puede recibir leads del proyecto (los no asignables se muestran con su motivo para desmarcarlos). */
  assignable: boolean;
  inactiveReason: string | null;
}

/**
 * Filas del diálogo de la regla (Lote 6 · I2, P6). Mientras la lista de asesores no llegó (`options` undefined:
 * cargando o con error) los ids guardados se tratan como válidos, con nombre provisional, para que Guardar nunca
 * mande una lista vacía por no tener con qué compararlos. Con la lista, un id guardado que no aparece (salió de
 * la empresa) se muestra como «Usuario ya no disponible», nunca el UUID, y no es válido.
 */
export function ruleAdvisorRows(
  options: AdvisorOption[] | undefined,
  savedIds: readonly string[],
): { rows: RuleAdvisorRow[]; listReady: boolean } {
  const listReady = !!options;
  const rows: RuleAdvisorRow[] = (options ?? [])
    .filter((a) => a.kind === 'HUMAN')
    .map((a) => ({
      id: a.id,
      fullName: a.fullName,
      role: a.role,
      isTestAccount: a.isTestAccount,
      assignable: a.assignable !== false,
      inactiveReason: a.inactiveReason ?? null,
    }));
  for (const id of savedIds)
    if (!rows.some((a) => a.id === id))
      rows.push({
        id,
        fullName: listReady ? 'Usuario ya no disponible' : 'Asesor guardado',
        role: 'ASESOR',
        isTestAccount: false,
        assignable: !listReady,
        inactiveReason: listReady ? 'ya no está en la empresa' : null,
      });
  return { rows, listReady };
}

/** Ids marcados que hoy pueden recibir leads (los que viajan al guardar y los que cuentan para las partes). */
export function validRuleAdvisorIds(
  rows: readonly RuleAdvisorRow[],
  advisorIds: readonly string[],
) {
  return advisorIds.filter((id) => rows.find((a) => a.id === id)?.assignable ?? false);
}
